/** What the sky bake asks of a filter, so one bake runs either of Godot's two filters. */
/** The uniforms of the filter passes that `skyLayers` sets, for the chain and the texel. */
export const LAYER_FILTER_UNIFORMS = ['chain', 'borderSize', 'layerSize'];
//# sourceMappingURL=layerFilter.js.map